__turbopack_context__.v({
  "button": "homepage-info-section-module-scss-module__doTdVq__button",
  "buttons": "homepage-info-section-module-scss-module__doTdVq__buttons",
  "container": "homepage-info-section-module-scss-module__doTdVq__container",
  "heading": "homepage-info-section-module-scss-module__doTdVq__heading",
  "headingContainer": "homepage-info-section-module-scss-module__doTdVq__headingContainer",
  "quickTipWrapper": "homepage-info-section-module-scss-module__doTdVq__quickTipWrapper",
  "quickTips": "homepage-info-section-module-scss-module__doTdVq__quickTips",
});
